/**
 * Download Worker Factory
 *
 * Isolates the `import.meta.url` worker-URL construction into its own module,
 * for the same reason `runStreamWorkerFactory` does: CRA's Jest runs tests in a
 * CommonJS context and cannot parse `import.meta`, so anything importing it
 * transitively becomes untestable. Keeping it here lets the S3 readers be unit
 * tested by mocking this factory — the production path is unchanged.
 *
 * @module shared/workers/downloadWorkerFactory
 */

export const createDownloadWorker = () =>
  new Worker(new URL('./downloadWorker.js', import.meta.url));
